import { schoolphotosPublishAtom, slidesPublishAtom } from "./atoms";

export const publishGroups = {
  schoolphotos: {
    models: ["studentworks", "schoolphotos"],
    singleItems: [],
    atom: schoolphotosPublishAtom,
  },
  slides: {
    models: ["slides"],
    singleItems: [],
    atom: slidesPublishAtom,
  },
};
